import { ChangeDetectionStrategy, Component, ElementRef, inject, OnInit } from '@angular/core';
import { Item } from '../../../../core/shared/item.model';
import { ViewMode } from '../../../../core/shared/view-mode.model';
import { listableObjectComponent } from '../../../../shared/object-collection/shared/listable-object/listable-object.decorator';
import { ItemComponent } from '../shared/item.component';

import { Fancybox } from '@fancyapps/ui';

import { Collection } from 'src/app/core/shared/collection.model';
import { getFirstCompletedRemoteData, getRemoteDataPayload } from 'src/app/core/shared/operators';
import { DOCUMENT } from '@angular/common';
import { hasValue } from 'src/app/shared/empty.util';
import { GalleryService } from 'src/app/shared/gallery/gallery.service';

/**
 * Component that represents a publication Item page
 */

@listableObjectComponent(Item, ViewMode.StandalonePage)
@Component({
  selector: 'ds-untyped-item',
  styleUrls: ['./untyped-item.component.scss'],
  templateUrl: './untyped-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UntypedItemComponent extends ItemComponent implements OnInit{
    private galleryService: GalleryService = inject(GalleryService);
    private document: Document = inject(DOCUMENT);
    originalCollection: Collection = undefined;

    public ngOnInit(): void {
      super.ngOnInit();
      this.galleryService.clearItems();

      this.handleMetadata();

      this.object.owningCollection.pipe(
        getFirstCompletedRemoteData(),
        getRemoteDataPayload()
      ).subscribe( (collection) => {
        if ( collection !== null ) {
          this.originalCollection = collection;
        }
      });
    }

    private handleMetadata(): void {
      /// Add Youtube videos
      let metadataValues: string[] = this.object.allMetadataValues( 'dcterms.isReferencedBy' );
      for ( let value of metadataValues ) {
        if ( value.startsWith( 'https://www.youtube.com/watch?v=' ) ) {
          this.galleryService.addYoutubeVideo( value );
        }
      }
    }

    public onThumbnailClicked( event: any ): void {
      event.stopPropagation();

      this.galleryService.open();
    }


  public getExtraFields(): any {
    if ( this.originalCollection === undefined ){
      return [];
    }

    if ( this.appConfig.extrafields === undefined ){
      return [];
    }

    /// handleUrl: https://dspace.fszek.hu/handle/123456789/1234
    /// handleUrl: hdl:123456789/1234
    let handleUrl: string = this.originalCollection.handle;
    let handle = '';
    let parts: string[] = handleUrl.split( '/' );
    if ( parts.length == 6 ){
      handle = parts[ 5 ];
    } else
    if ( parts.length == 2 ){
      handle = parts[ 1 ];
    }

    if ( this.appConfig.extrafields.hasOwnProperty( handle ) ){
      return this.appConfig.extrafields[ handle ];
    }
    return [];
  }
}
